import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import user from './modules/user';
import filters from './modules/filters/filters';

Vue.use(Vuex);

function initialState() {
  return {
    jiraResults: [],
    confluenceResults: [],
    startAt: 0,
    confluenceOpenedIndex: -1,
    commentOpenedIndex: -1,
    currentPage: 1,
    confluencePageIncrement: 1,
    jiraIncrementPage: 1,
    transition: 'list-left',
    showAnnouncement: false,
    loader: false,
  };
}

export default new Vuex.Store({
  state: initialState,
  modules: {
    user,
    filters,
  },
  actions,
  mutations: {
    ...{
      RESET_STORE(state) {
        const initState = initialState();
        Object.keys(initState).forEach((key) => {
          state[key] = initState[key];
        });
      },
    },
    ...mutations,
  },
});



// WEBPACK FOOTER //
// ./src/store/Store.js